import { ProfileEditComponent } from './../profile-edit/profile-edit.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ProfileAdvancedSearchExportDto } from './dto/profile-advanced-search-export.dto';
import { ProfileSearchAdvancedOptionsComponent } from './profile-search-advanced-options/profile-search-advanced-options.component';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ViewEncapsulation, ElementRef } from '@angular/core';
import { UtilService, DialogService, NotificationService, TranslationService, DatagridService, DialogModal } from '../../shared/index';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { PagedResult } from '../../shared/model/paged-result.model';
import { DataView as PrimeDataList } from 'primeng/dataview';
import { MenuItem } from 'primeng/api';
import { AsyncState } from '../../shared/model/index';
import { LocalStorageService } from '../../shared/storage/local-storage.service';
import { AuthService } from '../../shared/auth/auth.service';
import { ProfileSearchService } from './profile-search.service';
import { ProfileAdvancedSearchParams } from './profile-advanced-search-params.model';
import { ProfileSearchResult } from './profile-search-result.model';
import { ProfileSearchComponentModel } from './profile-search-component.model';
import { ProfileMin } from '../shared/profile-min.model';
import { MassCommParameterService } from 'src/app/communication/shared/mass-comm-parameter.service';
import { AffCodeMassAddComponent } from 'src/app/affcode/affcode-mass-add/affcode-mass-add.component';
import { BenefitService } from 'src/app/benefits/shared/benefit.service';
import { ProfileService } from '../shared/profile.service';
import { MembershipLevelDto } from 'src/app/benefits/shared/dto/membership-level.dto';
import { MemberActivitySearchActionComponent } from './search-actions/member-activity-search-action/member-activity-search-action.component';
import { AssignUserSearchActionComponent } from './search-actions/assign-user-search-action/assign-user-search-action.component';
import { SetStatusSearchActionComponent } from './search-actions/set-status-search-action/set-status-search-action.component';
import { CreateContactSearchActionComponent } from './search-actions/create-contact-search-action/create-contact-search-action.component';
import { CreateTaskSearchActionComponent } from './search-actions/create-task-search-action/create-task-search-action.component';
import { ConfigService } from 'src/app/config/shared/config.service';
import { ProfileSearchParameterService } from '../shared/profile-search-parameter.service';
import { AddReferralDialogComponent } from '../profile-view/referral-report/add-referral-dialog/add-referral-dialog.component';
import { MultipleProfileInvoiceModalComponent } from './search-actions/multiple-profile-invoice-modal/multiple-profile-invoice-modal.component';
import { UserService } from 'src/app/users/shared/user.service';
import { ConfigServiceApiService } from 'src/app/shared/api/config-service-api.service';
import { ConfigServiceService } from 'src/app/config/shared/config-service.service';
import { ProfileSelectorConfigDto } from './dto/profile-selector-config.dto';
import { PagedDataTableDto } from 'src/app/shared/dto/paged-datatable.dto';
import { ProfileSelectorResultsComponent } from './profile-selector-results/profile-selector-results.component';
import { ProfileSelectorColumnMetaDataDto } from './dto/profile-selector-column-meta-data.dto';
import { ProfileSelectorColumnMetadataService } from './profile-selector-column-metadata.service';
import { timeoutWrapper } from 'src/app/shared/decorator/timeout-wrapper';
import { ProfileSearchManageColumnsComponent } from './profile-search-manage-columns/profile-search-manage-columns.component';

@Component({
  selector: 'wl-profile-search',
  templateUrl: 'profile-search.component.html',
  providers: [ProfileSearchService, MassCommParameterService, ProfileSearchParameterService],
  styleUrls: ['profile-search.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProfileSearchComponent implements OnInit {
  @ViewChild('profilesDataGrid', { static: false }) public _profilesDataGrid: PrimeDataList;
  @ViewChild(ProfileSearchAdvancedOptionsComponent) private _advancedSearch: ProfileSearchAdvancedOptionsComponent;
  @ViewChild(MemberActivitySearchActionComponent) private _memberActivitySearchAction: MemberActivitySearchActionComponent;
  @ViewChild(AssignUserSearchActionComponent) private _assignUserSearchAction: AssignUserSearchActionComponent;
  @ViewChild(SetStatusSearchActionComponent) private _setStatusAction: SetStatusSearchActionComponent;
  @ViewChild(CreateContactSearchActionComponent) private _createContactAction: CreateContactSearchActionComponent;
  @ViewChild(CreateTaskSearchActionComponent) private _createTaskAction: CreateTaskSearchActionComponent;
  @ViewChild(AddReferralDialogComponent) private _addReferralAction: AddReferralDialogComponent;
  @ViewChild(MultipleProfileInvoiceModalComponent) private _multipleProfileInvoice: MultipleProfileInvoiceModalComponent;
  @ViewChild(ProfileSearchManageColumnsComponent) private _manageColumns: ProfileSearchManageColumnsComponent;

  // indicate whether or not to load data from the api
  public _fullLazyLoad: boolean;
  public initComplete: boolean;

  public isSearching: boolean;
  public isExporting: boolean;
  public selectedAction: number;
  public useDuesBillingDate: boolean;
  public hasEventBenefits: boolean;
  public loading: AsyncState;
  public results: ProfileSearchResult;
  public profileSearchComponentModel: ProfileSearchComponentModel;
  public selectAll: boolean;
  public actionsText: string;
  public actionsOptions: MenuItem[];
  public selectedPageSize: number;
  public pageSizeOptions: Array<SelectItem>;
  public safeSearch: boolean;
  public showAffCodeAddDialog = false;
  public showAffCodeRemoveDialog = false;
  public showAssignMembershipLevelDialog = false;
  public membershipLevels = [];
  public selectedMembershipLevelId = 0;
  public showCreateMemberActivityDialog = false;
  public showAssignUserDialog = false;
  public showSetStatusDialog = false;
  public showCreateContactDialog = false;
  public hasTasks = false;
  public showEdit: boolean;
  public isSaving = false;
  public showMultiProfileInvoice: boolean = false;
  public profileSearchConfigSettings: ProfileSelectorConfigDto;
  public profileSelectorColumnMetaData = Array<ProfileSelectorColumnMetaDataDto>();
  public showProfileSelectorConfig = false;
  public runProfileSelectorAdvancedSearch = false;
  public showProfileSelectorGrid = false;
  public pagedProfileSelectorDataTableResults = {} as PagedDataTableDto;
  public swapToV2OnNextSearch = false;
  public swapToV1OnNextSearch = false;

  @Input() public singleProfileSelect: boolean = false;
  @Output() onProfileSelected: EventEmitter<ProfileMin> = new EventEmitter<ProfileMin>();
  @Input() public showMemberColumn: boolean = false;
  @Input() public showOrgIndColumn: boolean = false;
  @Input() public showCustStatusColumn: boolean = false;
  @Input() public alwaysExpandAdvancedSearch: boolean = false;
  @Input() public hideFooter = false;
  @ViewChild('profilesDataGrid', { read: ElementRef }) private resultsGrid: ElementRef;
  @ViewChild('wlAffCodeMassAdd') private affCodeMassAddComponent: AffCodeMassAddComponent;
  @ViewChild('wlAffCodeMassRemove') private affCodeMassRemoveComponent: AffCodeMassAddComponent;
  @ViewChild(ProfileEditComponent) profileEditComponent: ProfileEditComponent;
  @ViewChild(ProfileSelectorResultsComponent) profileSelectorResultsComponent: ProfileSelectorResultsComponent;

  public get columnCount() {
    return (
      2 * +this.singleProfileSelect +
      3 * +!this.singleProfileSelect +
      +this.showCustStatusColumn +
      +this.showOrgIndColumn +
      +this.showMemberColumn +
      3
    );
  }

  public constructor(
    private _notifyService: NotificationService,
    public _translationService: TranslationService,
    private _navigationService: NavigationService,
    private _dataGridService: DatagridService,
    private _dialogService: DialogService,
    private _authService: AuthService,
    private _massCommParameterService: MassCommParameterService,
    private _localStorageService: LocalStorageService,
    private _benefitService: BenefitService,
    private _profileSearchService: ProfileSearchService,
    private _profileSearchParameterService: ProfileSearchParameterService,
    private _profileService: ProfileService,
    private _configService: ConfigService,
    private _userService: UserService,
    private _configServiceService: ConfigServiceService,
    private _confirmationService: ConfirmationService,
    private _profileSelectorColumnMetadataService: ProfileSelectorColumnMetadataService
  ) {
    this.loading = new AsyncState();
    this._fullLazyLoad = false;
    this.useDuesBillingDate = false;
    this.initComplete = false;
    this.hasEventBenefits = true;
    this.profileSearchComponentModel = new ProfileSearchComponentModel();
    this.profileSearchComponentModel.searchParams.OrderBy = 'ASF';
    this.selectedPageSize = 20;
  }

  ngOnInit() {
    this.initActionsOptions();

    if (this._profileSearchParameterService.hasResults()) {
      const tempComponentModel = this._profileSearchParameterService.getProfileSearchResults();
      const options = this._profileSearchParameterService.getSearchLoadOptions();
      this._profileSearchParameterService.clearSearchLoadOptions();
      const promise = this._authService.getUserInfo().then((x) => {
        if (
          (!tempComponentModel.userNum || tempComponentModel.userNum == x.wli_usernum) &&
          (!tempComponentModel.clientId || tempComponentModel.clientId == x.client_id)
        ) {
          this.profileSearchComponentModel = tempComponentModel;
        } else {
          this.profileSearchComponentModel.userNum = x.wli_usernum;
          this.profileSearchComponentModel.clientId = x.client_id;
        }
        this.initComplete = true;

        if (options?.RunOnLoad) {
          this.searchProfiles();
        }

        if (this.alwaysExpandAdvancedSearch && !options?.HideAdvancedParams) {
          this.profileSearchComponentModel.showAdvancedSearch = true;
        }
      });
    } else {
      this.initComplete = true;

      if (this.alwaysExpandAdvancedSearch) {
        this.profileSearchComponentModel.showAdvancedSearch = true;
      }
    }
    this._benefitService.getMembershipLevels().then((data) => {
      this.membershipLevels = data.Result.map<SelectItem>((x) => {
        return { label: x.Name, value: x.MembershipLevelId };
      });
    });

    this._authService.getUserInfo().then((user) => {
      this._configServiceService.checkForProfileSearchConfig(user.wli_usernum).then((value) => {
        const options = this._profileSearchParameterService.getSearchLoadOptions();
        if (options?.HideAdvancedParams && options?.FromNavigation) {
          this.profileSearchComponentModel.showAdvancedSearch = false;
        }
        this.setProfileSearchConfigSettings(value, user.wli_usernum).then(() => {
          this.runProfileSelectorAdvancedSearch = true;
          this.showProfileSelectorGrid = true;
          this.profileSearchComponentModel.searchParams.OrderBy = this.profileSearchComponentModel.searchParams.OrderBy.replace(
            /\basf\b/i,
            'Profile Name'
          );
        });
      });
    });
  }

  public handleShowAdvancedSearch() {
    this.profileSearchComponentModel.showAdvancedSearch = true;
  }

  public handleHideAdvancedSearch() {
    this.profileSearchComponentModel.showAdvancedSearch = false;
  }

  public handleEditClick(profileId: number) {
    this._navigationService.navigateToProfileBenefitsManagement(profileId);
  }

  public handlePageSizeChange($event) {
    if ($event) {
      this.profileSearchComponentModel.searchParams.PageSize = $event;
      this._profilesDataGrid.rows = $event;
      this.safeSearch = false;
      this.lazyLoadProfiles({ first: 0, rows: $event });
    }
  }

  public onSelectAllChange(selectAll: boolean) {
    // change tracked state for count display
    this.selectAll = selectAll;

    // reset the tracking array
    this.profileSearchComponentModel.selectedProfiles = new Array<number>();

    for (const item of this.profileSearchComponentModel.profiles.Result) {
      item.Selected = selectAll;
    }
    // save the model for later
    this._profileSearchParameterService.setProfileSearchResults(this.profileSearchComponentModel);
  }

  public onProfileSelectedChange(item: any) {
    // track it if it doesn't match the selectAllProfiles variable
    if (item.Selected != this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.selectedProfiles.push(item.ProfileId);
    } else {
      const ind = this.profileSearchComponentModel.selectedProfiles.findIndex((x) => x == item.ProfileId);
      if (ind != null) {
        this.profileSearchComponentModel.selectedProfiles.splice(ind, 1);
      }
    }
    // save the model for later
    this._profileSearchParameterService.setProfileSearchResults(this.profileSearchComponentModel);
  }

  public searchProfiles() {
    // If the user has saved V2 Settings for the first time then swap over to the new grid and search.
    if (this.swapToV2OnNextSearch) {
      this.showProfileSelectorGrid = true;
      this.runProfileSelectorAdvancedSearch = true;
    } else if (this.swapToV1OnNextSearch) {
      this.showProfileSelectorGrid = true;
      this.runProfileSelectorAdvancedSearch = false;
      this.profileSearchComponentModel.searchParams.OrderBy = 'ASF';
    }

    if (!this.runProfileSelectorAdvancedSearch) {
      if (this._profilesDataGrid) {
        (<any>this._profilesDataGrid).first = 0;
      }
      this.profileSearchComponentModel.searchParams.PageNumber = 1;
      //reset the tracking array
      this.profileSearchComponentModel.selectedProfiles = new Array<number>();
      this.profileSearchComponentModel.selectAllProfiles = false;
      this._fullLazyLoad = true;
    }
    this.lazyLoadProfiles({ first: 0, rows: this.selectedPageSize });
  }

  public clearProfiles() {
    setTimeout(() => {
      this.profileSearchComponentModel.searchParams = new ProfileAdvancedSearchParams();
      if (this.runProfileSelectorAdvancedSearch) {
        this.profileSearchComponentModel.searchParams.OrderBy = 'Profile Name:asc';
      } else {
        this.profileSearchComponentModel.searchParams.OrderBy = 'ASF';
      }
    });
    //reset the tracking array
    this.profileSearchComponentModel.selectAllProfiles = false;
    this.profileSearchComponentModel.searchParams.IgnoreProfiles = [];
    this.profileSearchComponentModel.searchParams.PermitProfiles = [];
    this.profileSearchComponentModel.selectedProfiles = new Array<number>();
    this.profileSearchComponentModel.profiles = new ProfileSearchResult();
    this._profileSearchParameterService.clearProfileSearchResults();
    this._advancedSearch.isSearching = false;
    this.safeSearch = false;
    this.selectedPageSize = 20;
    this._profilesDataGrid.rows = 20;
    this.selectAll = false;
  }
  @timeoutWrapper()
  public lazyLoadProfiles($event: any) {
    if (this.runProfileSelectorAdvancedSearch) {
      this.profileSelectorResultsComponent.reset();
      this.profileSelectorResultsComponent.search().then((results) => {
        this.profileSelectorResultsComponent.searchResult = results;
        this.isSearching = false;
        this._advancedSearch.isSearching = false;
        this.loading.busy = false;
        this.loading.success = true;
        this._profileSearchParameterService.setProfileSearchResults(this.profileSearchComponentModel);
        if (this.swapToV2OnNextSearch) {
          this.swapToV2OnNextSearch = false;
        }
      });
    } else {
      // this is a hack. the page numbers don't work unless lazy load is on and setting the page numbers from the cache on init triggers this method.
      if (!this.initComplete) return;

      // if the user has selected to display all, first verify that there aren't more than 1000 rows.
      if (this.selectedPageSize === 1001 && !this.safeSearch) {
        this.profileSearchComponentModel.searchParams.PageSize = 1;
      }

      this._dataGridService.mapDatagridPagingToPagedSearch($event, this.profileSearchComponentModel.searchParams);
      if ($event) {
        this.profileSearchComponentModel.searchParams.PageNumber = $event.first / Math.max(1, $event.rows) + 1;
        this.profileSearchComponentModel.searchParams.PageSize = this.selectedPageSize;
      }

      if (!this._fullLazyLoad) {
        // we got the data from local storage. don't load data from the api.
        this._fullLazyLoad = true;
        return;
      }

      this.loading.busy = true;
      this.loading.success = false;
      this.isSearching = true;

      this._profileSearchService
        .advancedSearch(this.profileSearchComponentModel.searchParams)
        .then((data: PagedResult) => {
          if (this.selectedPageSize === 1001 && !this.safeSearch) {
            // check to see if we can run the full display all option
            if (data.TotalCount <= 1000) {
              this.safeSearch = true;
              this.lazyLoadProfiles({ first: 0, rows: $event });
              return;
            } else {
              this._notifyService.error(this._translationService.getInstant('profiles.search.page-size.warning'));
              return;
            }
          } else {
            this.profileSearchComponentModel.profiles = data;
            this.isSearching = false;
            this.loading.busy = false;
            this.loading.success = true;
            this._profileSearchParameterService.setProfileSearchResults(this.profileSearchComponentModel);

            this.profileSearchComponentModel.profiles.Result.forEach(
              (x) =>
                (x.Selected =
                  this.profileSearchComponentModel.selectAllProfiles !==
                  this.profileSearchComponentModel.selectedProfiles.indexOf(x.ProfileId) > -1)
            );

            this._advancedSearch.isSearching = false;
            const el = this.resultsGrid.nativeElement;
            window.scrollTo(window.scrollX, el.offsetTop + 600);
          }
        })
        .catch((error) => {
          this._notifyService.httpError(error);
          this.profileSearchComponentModel.profiles = { TotalCount: 0 } as PagedResult;
          this.isSearching = false;
          this.loading.busy = false;
          this.loading.success = false;
          this._advancedSearch.isSearching = false;
        });
    }
  }

  public removeSelected() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.PermitProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
    } else {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
    }
    this.searchProfiles();
    this._notifyService.success(this._translationService.getInstant('common.success'));
  }

  public singleProfileSelected(profile: ProfileMin) {
    this.onProfileSelected.emit(profile);
  }

  private async initActionsOptions() {
    const actionsLabel = await this._translationService.get('profiles.search.actions.label');
    const removeSelectedLabel = await this._translationService.get('profiles.search.actions.remove-selected');
    const exportToCsvLabel = await this._translationService.get('profiles.search.actions.export-to-csv');
    const exportSystemColumnsLabel = await this._translationService.get('profiles.search.actions.export-system-columns');
    const emailSelectedLabel = await this._translationService.get('profiles.search.actions.email-selected');
    const addAffiliationLabel = await this._translationService.get('profiles.search.actions.add-affiliations');
    const removeAffiliationLabel = await this._translationService.get('profiles.search.actions.remove-affiliations');
    const assignToMembershipLevelLabel = await this._translationService.get('profiles.search.actions.assign-to-membership-level');
    const createMemberActivityLabel = await this._translationService.get('profiles.search.actions.create-member-activity');
    const assignUsersLabel = await this._translationService.get('profiles.search.actions.assign-users');
    const setStatusLabel = await this._translationService.get('profiles.search.actions.set-status');
    const setProspectLabel = await this._translationService.get('profiles.search.actions.set-prospect');
    const createContactLabel = await this._translationService.get('profiles.search.actions.create-contact');
    const createTaskLabal = await this._translationService.get('profiles.search.actions.create-task');
    const createReferralLabal = await this._translationService.get('profiles.search.actions.create-referral');
    const multipleProfileInvoiceLabel = await this._translationService.get('profiles.search.actions.multiple-profile-invoice-label');

    const massCommAccess = await this._userService.getCurrentUserSecurityElementAccessLevel('Send_Mass_Communicatons');
    let massCommVisible = massCommAccess > 0;

    const revenueAccess = await this._userService.getCurrentUserSecurityElementAccessLevel('Revenue_Module');
    const revenueVisible = revenueAccess === 2;

    this.actionsText = actionsLabel;
    this.actionsOptions = [
      {
        label: removeSelectedLabel,
        command: (event) => {
          this.removeSelected();
        },
      },
      {
        label: exportToCsvLabel,
        disabled: this.isExporting,
        command: () => {
          this.exportAllToCsv();
        },
      },
      {
        label: emailSelectedLabel,
        disabled: this.isExporting,
        visible: massCommVisible,
        command: () => {
          this.navigateToMassComm();
        },
      },
      {
        label: multipleProfileInvoiceLabel,
        disabled: this.isExporting,
        visible: revenueVisible,
        command: () => {
          if (this.profileSearchComponentModel.selectAllProfiles) {
            this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
            this.profileSearchComponentModel.searchParams.PageNumber = 0;
            this.profileSearchComponentModel.searchParams.PageSize = 0;
            let profileIds = [];

            this._profileSearchService.advancedSearch(this.profileSearchComponentModel.searchParams).then((results) => {
              profileIds = results.Result.map((x) => {
                return x.ProfileId;
              });

              this._multipleProfileInvoice.open(profileIds);
            });
          } else {
            if (this.profileSearchComponentModel.selectedProfiles) {
              if (this.profileSearchComponentModel.selectedProfiles.length > 500) {
                this._notifyService.error(
                  this._translationService.getInstant('profiles.search.actions.multiple-profile-invoice-modal.too-many-profiles')
                );
                return;
              }

              this._multipleProfileInvoice.open(this.profileSearchComponentModel.selectedProfiles);
            }
          }
        },
      },
      {
        label: addAffiliationLabel,
        disabled: this.isExporting,
        command: () => {
          this.showAffCodeAddDialog = true;
        },
      },
      {
        label: removeAffiliationLabel,
        disabled: this.isExporting,
        command: () => {
          this.showAffCodeRemoveDialog = true;
        },
      },
      {
        label: assignToMembershipLevelLabel,
        disabled: this.isExporting,
        automationId: 'menuAssignMembershipLevel',
        command: () => {
          this.showAssignMembershipLevelDialog = true;
        },
      },
      {
        label: createMemberActivityLabel,
        disabled: this.isExporting,
        command: () => {
          this.showCreateMemberActivityDialog = true;
        },
      },
      {
        label: assignUsersLabel,
        disabled: this.isExporting,
        command: () => {
          this.showAssignUserDialog = true;
        },
      },
      {
        label: setStatusLabel,
        disabled: this.isExporting,
        command: () => {
          this.showSetStatusDialog = true;
        },
      },
      {
        label: setProspectLabel,
        disabled: this.isExporting,
        command: () => {
          const dialog = new DialogModal();
          dialog.yesText = this._translationService.getInstant('profiles.search.set-profile-prospect').toUpperCase();
          dialog.noText = this._translationService.getInstant('common.cancel').toUpperCase();
          dialog.headerText = setProspectLabel;
          dialog.messageText = this._translationService.getInstant('profiles.search.set-profile-prospect-note');
          dialog.showCancel = false;
          dialog.show = true;
          dialog.yesFunction = () => {
            this.massSetProspect();
          };
          this._dialogService.addDialog(dialog);
        },
      },
      {
        label: createContactLabel,
        disabled: this.isExporting,
        command: () => {
          this.showCreateContactDialog = true;
        },
      },
      {
        label: createTaskLabal,
        disabled: this.isExporting,
        command: () => {
          this._createTaskAction.open(this.profileSearchComponentModel);
        },
      },
      {
        label: createReferralLabal,
        disabled: this.isExporting,
        command: () => {
          this._addReferralAction.open(true, this.profileSearchComponentModel);
        },
      },
    ];

    Promise.all([
      this._translationService.get('profiles.search.page-size.show-20'),
      this._translationService.get('profiles.search.page-size.show-100'),
      this._translationService.get('profiles.search.page-size.show-all'),
    ]).then((data: string[]) => {
      this.pageSizeOptions = [
        { label: data[0], value: 20 },
        { label: data[1], value: 100 },
        { label: data[2], value: 1001 },
      ];
    });
  }
  navigateToMassComm() {
    this._massCommParameterService.setProfileSearchParams(this.profileSearchComponentModel.searchParams);
    this._navigationService.navigateToCommunicationNewEmailMessage();
  }

  massAddAffCode() {
    this.affCodeMassAddComponent.setProfileIds(this.profileSearchComponentModel.profiles.Result.map((x) => x.ProfileId));
  }

  closeEdit() {
    this.showEdit = false;
  }

  saveOpenProfile() {
    this.isSaving = true;
    this.profileEditComponent.saveClick().then(() => {
      this.isSaving = false;
      this.showEdit = false;
    });
  }

  onEditClicked(profileId) {
    this.profileEditComponent.isLoading = true;
    this.showEdit = true;
    this.profileEditComponent.profileId = profileId;
    this.profileEditComponent.setupComponentData();
  }

  private exportAllToCsv() {
    this.isExporting = true;
    const exportDto = {
      ProfileAdvancedSearchDto: this.profileSearchComponentModel.searchParams,
      SelectedProfileIds: this.profileSearchComponentModel.selectedProfiles,
    } as ProfileAdvancedSearchExportDto;
    this._profileSearchService.exportSearchToCsv(exportDto, true).then(
      (url) => {
        if (url) {
          this._navigationService.popupSafeNavigate(url);
        } else {
          this._notifyService.error(this._translationService.getInstant('profiles.search.export-empty'));
        }
        this.isExporting = false;
      },
      () => {
        this.isExporting = false;
      }
    );
  }

  public keywordKeypress(event) {
    if (event.keyCode == 13) {
      this.searchProfiles();
    }
  }

  public cancelAffCodeAdd() {
    this.showAffCodeAddDialog = false;
  }

  public massAddAffCodes() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
      this.affCodeMassAddComponent.addAffCodesAdvanced(this.profileSearchComponentModel.searchParams);
      this._notifyService.success(this._translationService.getInstant('profiles.search.affcode-add-success'));
    } else {
      this.affCodeMassAddComponent.setProfileIds(this.profileSearchComponentModel.selectedProfiles);
      this.affCodeMassAddComponent.addAffCodes();
      this._notifyService.success(this._translationService.getInstant('common.success'));
    }
    this.showAffCodeAddDialog = false;
  }

  public cancelAffCodeRemove() {
    this.showAffCodeRemoveDialog = false;
  }

  public massRemoveAffCodes() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
      this.affCodeMassRemoveComponent.removeAffCodesAdvanced(this.profileSearchComponentModel.searchParams);
      this._notifyService.success(this._translationService.getInstant('profiles.search.affcode-remove-success'));
    } else {
      this.affCodeMassRemoveComponent.setProfileIds(this.profileSearchComponentModel.selectedProfiles);
      this.affCodeMassRemoveComponent.removeAffCodes();
      this._notifyService.success(this._translationService.getInstant('common.success'));
    }
    this.showAffCodeRemoveDialog = false;
  }

  public cancelAssignMembershipLevels() {
    this.showAssignMembershipLevelDialog = false;
  }

  public massAssignMembershipLevels() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
      this._profileService.assignMembershipLevelAdvanced(this.profileSearchComponentModel.searchParams, this.selectedMembershipLevelId);
      this._notifyService.success(this._translationService.getInstant('profiles.search.affcode-remove-success'));
    } else {
      this._profileService.assignMembershipLevel(this.profileSearchComponentModel.selectedProfiles, this.selectedMembershipLevelId);
      this._notifyService.success(this._translationService.getInstant('common.success'));
    }
    this.showAssignMembershipLevelDialog = false;
  }

  public cancelCreateActivity() {
    this.showCreateMemberActivityDialog = false;
  }

  public massCreateMemberActivity() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
      this._memberActivitySearchAction.massCreateMemberActivity(this.profileSearchComponentModel.searchParams);
      this._notifyService.success(this._translationService.getInstant('profiles.search.affcode-remove-success'));
    } else {
      this._memberActivitySearchAction.createMemberActivities(this.profileSearchComponentModel.selectedProfiles);
      this._notifyService.success(this._translationService.getInstant('common.success'));
    }
    this.showCreateMemberActivityDialog = false;
  }

  public cancelAssignUser() {
    this.showAssignUserDialog = false;
  }

  public massAssignUser() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
      this._assignUserSearchAction.massAssignProfileUser(this.profileSearchComponentModel.searchParams);
    } else {
      this._assignUserSearchAction.assignProfilesUser(this.profileSearchComponentModel.selectedProfiles);
    }
    this.showAssignUserDialog = false;
  }

  public cancelSetStatus() {
    this.showSetStatusDialog = false;
  }

  public massSetStatus() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
      this._setStatusAction.massSetStatus(this.profileSearchComponentModel.searchParams);
    } else {
      this._setStatusAction.setStatus(this.profileSearchComponentModel.selectedProfiles);
    }
    this.showSetStatusDialog = false;
  }

  public massSetProspect() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
      this._profileService.setProfilesProspectAdvanced(this.profileSearchComponentModel.searchParams).then(() => {
        this._notifyService.translateSuccess('profiles.search.set-prospect-success');
      });
    } else {
      this._profileService
        .setProfilesProspect(this.profileSearchComponentModel.selectedProfiles)
        .then(() => {
          this._notifyService.translateSuccess('common.success');
        })
        .catch((error) => {
          this._notifyService.httpError(error);
        });
    }
  }

  public cancelCreateContact() {
    this.showCreateContactDialog = false;
  }

  public massCreateContact() {
    if (this.profileSearchComponentModel.selectAllProfiles) {
      this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
      this._createContactAction.massCreateProfilesContact(this.profileSearchComponentModel.searchParams);
    } else {
      this._createContactAction.createProfilesContact(this.profileSearchComponentModel.selectedProfiles);
    }
    this.showCreateContactDialog = false;
  }

  openProfileSelectorConfig() {
    this.showProfileSelectorConfig = true;
  }

  setSwapToV2OnNextSearch() {
    // Clear out the Orderby when swapping in case the new custom columns do not include the ordered by system column.
    this.profileSearchComponentModel.searchParams.OrderBy = 'Profile Name:asc';

    if (this.runProfileSelectorAdvancedSearch == false) {
      this.swapToV2OnNextSearch = true;
    }
  }

  settingsCleared() {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('profiles.search.manage-columns.confirm-clear-message'),
      key: 'clearColumnsCD',
      accept: () => {
        this._authService
          .getUserInfo()
          .then(async (user) => {
            const defaultConfig = this._configServiceService.getDefaultProfileSearchConfig();
            await this._configServiceService.upsertProfileSearchConfig(defaultConfig);
            await this._configServiceService.getProfileSearchConfig(user.wli_usernum).then((data) => {
              this.profileSearchConfigSettings = data;
            });
          })
          .catch((error) => {
            this._notifyService.httpError(error);
          });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }

  setProfileSearchConfigSettings(hasSettings: boolean, userNum: string) {
    if (hasSettings) {
      return this._configServiceService.getProfileSearchConfig(userNum).then((data) => {
        this.profileSearchConfigSettings = data;
      });
    } else {
      const defaultConfig = this._configServiceService.getDefaultProfileSearchConfig();
      return this._configServiceService.upsertProfileSearchConfig(defaultConfig).then(() => {
        this._configServiceService.getProfileSearchConfig(userNum).then((data) => {
          this.profileSearchConfigSettings = data;
        });
      });
    }
  }
}
